import React, { useEffect, useContext } from 'react';
import useIsScrolled from 'hooks/useIsScrolled';
import SimpleHeader from 'components/Header/SimpleHeader';
import WebsiteHeader from 'components/Header/WebsiteHeader';
import ContentfulEditWidget from 'components/ContentfulEditWidget';
import { ProgressBar } from 'scrolling-based-progressbar';
import useExternalBanner from 'hooks/useExternalBanner';
import useScrollPosition from 'hooks/useScrollPosition';
import HeaderNavContext from 'utils/HeaderNavContext';
import { HeaderContainer, HorizontalProgressBar } from './styles';

const HeaderWrapper = ({
  contentfulId,
  anchorLinkNavigation,
  header = {},
  globalPromoBar,
  noHero,
  theme,
  SubNav,
  useProgressbar,
}) => {
  const { showSimpleOrMain, setShowSimpleOrMain } = useContext(HeaderNavContext);
  const bannerHeight = useExternalBanner();
  const { isScrolled } = useIsScrolled();
  const enableSimpleHeader = theme === 'SIMPLE_HEADER';

  const {
    announcementBarCopy,
    announcementBarLinkTitle,
    announcementBarLinkUrl,
    customPhoneNumber,
    landingPage,
    showAdditionalMenuItems,
    logoRoute,
    logoType,
    navigation,
    showMainMenuItems,
    mobileUseGlobalNav,
    mobileTransparentNav,
    desktopPromoCopy,
    mobilePromoCopy,
    promoDetails,
  } = header;

  const announcementBar = {
    copy: announcementBarCopy,
    linkTitle: announcementBarLinkTitle,
    linkUrl: announcementBarLinkUrl,
    hideSignIn: !showAdditionalMenuItems?.includes('Sign In'),
  };

  const promoBar = {
    desktopPromoCopy,
    mobilePromoCopy,
    promoDetails,
  };

  const contextualCta = header.contextualCta && header.contextualCta[0];
  const inline = !anchorLinkNavigation ? false : !anchorLinkNavigation.isInlineAnchorMenu;

  useEffect(() => {
    if (setShowSimpleOrMain) {
      setShowSimpleOrMain(theme === 'SIMPLE_HEADER');
    }
  }, [theme]);

  useScrollPosition(
    () => {
      if (document.body.style.overflow !== 'hidden' && enableSimpleHeader) {
        if (setShowSimpleOrMain) {
          setShowSimpleOrMain(true);
        }
      }
    },
    [],
    null,
    false,
    0,
  );

  return (
    <HeaderContainer
      hasAnchorLinkNavigation={anchorLinkNavigation !== undefined}
      className={`header-container ${showSimpleOrMain ? 'show-simple' : ''}`}
      data-testid="header-wrapper"
      bannerData={{ scrolled: isScrolled, height: bannerHeight || 0 }}
      showSimpleOrMain={showSimpleOrMain}
      inline={inline}
    >
      <ContentfulEditWidget id={contentfulId} isHeader />
      <SimpleHeader />
      <WebsiteHeader
        mobileTransparentNav={mobileTransparentNav}
        mobileUseGlobalNav={mobileUseGlobalNav}
        announcementBar={announcementBar}
        promoBar={promoBar}
        globalPromoBar={globalPromoBar}
        contextualCta={contextualCta}
        customPhoneNumber={customPhoneNumber}
        inline={inline}
        landingPage={landingPage}
        showAdditionalMenuItems={showAdditionalMenuItems}
        logoRoute={logoRoute}
        logoType={logoType}
        navigation={navigation}
        showMainMenuItems={showMainMenuItems}
        simpleHeader={enableSimpleHeader}
        noHero={noHero}
        theme={theme}
        SubNav={SubNav}
      />

      {useProgressbar && (
        <HorizontalProgressBar role="progressbar" isScrolled={isScrolled}>
          <div />
          <ProgressBar
            height="4px"
            color="var(--titan-blue-3)"
            bgColor="transparent"
            left="10%"
            bottom="-4px"
            zIndex="999"
            postition="absolute"
          />
        </HorizontalProgressBar>
      )}
    </HeaderContainer>
  );
};

export default HeaderWrapper;
